import { IndicatorType, QuoteFinancialAttachment, QuoteFinancialAttachmentType } from '../../constants/common'
import IndicatorBaseConfig from './indicatorBaseConfig'

export class ShrtraConfig extends IndicatorBaseConfig {
  static quoteFinancialAttachments: QuoteFinancialAttachmentType[] = [QuoteFinancialAttachment.shortInterest]
  static type = IndicatorType.Shrtra
  static label = 'Short Ratio'
  static shortLabel = 'Short Ratio'
  static seoLabel = 'Short Interest, Short Ratio'
  static abbreviation = 'shrtra'
}
